import { useCallback } from 'react';
import { useNavigate } from 'js/hooks/navigate';

export const useLaunchByRedirect = () => {
    const redirect = useNavigate({ redirect: true });

    return useCallback(({ launcherUrl }: { launcherUrl: string }): void => {
        redirect(launcherUrl);
    }, [redirect]);
};
